const pillars = [
  { label: 'Reclaim Hearts', icon: 'ri-heart-2-line' },
  { label: 'Reclaim Worship', icon: 'ri-music-2-line' },
  { label: 'Reclaim Purpose', icon: 'ri-compass-3-line' },
  { label: 'Reclaim a Generation', icon: 'ri-group-line' },
];

const AboutConference = () => {
  return (
    <section
      id="about"
      className="relative py-28 px-6 overflow-hidden"
      style={{ background: 'linear-gradient(180deg, #060606 0%, #0c0c0c 100%)' }}
    >
      {/* Top border glow */}
      <div
        className="absolute top-0 left-0 right-0 h-px pointer-events-none"
        style={{ background: 'linear-gradient(90deg, transparent 0%, rgba(212,168,66,0.65) 50%, transparent 100%)' }}
      />
      {/* Top radial burst */}
      <div
        className="absolute -top-20 left-1/2 -translate-x-1/2 w-full h-56 pointer-events-none"
        style={{ background: 'radial-gradient(ellipse at center, rgba(212,168,66,0.1) 0%, transparent 65%)' }}
      />
      {/* Background texture pattern */}
      <div
        className="absolute inset-0 pointer-events-none opacity-[0.025]"
        style={{
          backgroundImage: `repeating-linear-gradient(0deg, transparent, transparent 40px, rgba(212,168,66,0.8) 40px, rgba(212,168,66,0.8) 41px), repeating-linear-gradient(90deg, transparent, transparent 40px, rgba(212,168,66,0.8) 40px, rgba(212,168,66,0.8) 41px)`,
        }}
      />

      <div className="max-w-2xl mx-auto text-center relative z-10">
        {/* Badge */}
        <div
          className="inline-flex items-center gap-2 mb-7 px-5 py-1.5 rounded-full text-xs font-bold tracking-widest uppercase"
          style={{
            background: 'rgba(212,168,66,0.1)',
            border: '1px solid rgba(212,168,66,0.35)',
            color: '#D4A842',
            fontFamily: "'Glacial Indifference', sans-serif",
          }}
        >
          <span style={{ color: '#D4A842' }}>✦</span> About the Conference
        </div>

        {/* Revive Nation — Holy Midnight */}
        <h2
          className="font-black leading-none mb-2"
          style={{
            fontFamily: "'Holy Midnight', cursive",
            fontSize: 'clamp(2.4rem, 8vw, 4.2rem)',
            color: '#FFFFFF',
            textShadow: '0 0 50px rgba(212,168,66,0.25)',
            letterSpacing: '0.01em',
          }}
        >
          Revive Nation
        </h2>

        {/* Reclaim Conference — Bacalisties */}
        <h3
          className="font-bold mb-10"
          style={{
            fontFamily: "'Bacalisties', cursive",
            fontSize: 'clamp(1.3rem, 4.5vw, 2.2rem)',
            color: '#D4A842',
            textShadow: '0 0 28px rgba(212,168,66,0.6)',
            letterSpacing: '0.03em',
          }}
        >
          Reclaim Conference
        </h3>

        {/* Body text card */}
        <div
          className="rounded-2xl p-7 md:p-9 text-left mb-10 relative overflow-hidden"
          style={{
            background: 'linear-gradient(145deg, rgba(212,168,66,0.08) 0%, rgba(255,255,255,0.02) 100%)',
            border: '1px solid rgba(212,168,66,0.2)',
          }}
        >
          {/* Corner accent */}
          <div
            className="absolute top-0 right-0 w-24 h-24 pointer-events-none"
            style={{ background: 'radial-gradient(circle at top right, rgba(212,168,66,0.12) 0%, transparent 70%)' }}
          />
          <p className="text-base md:text-lg text-gray-200 leading-loose mb-5" style={{ fontFamily: "'Glacial Indifference', sans-serif" }}>
            Revive Nation – Reclaim Conference is a{' '}
            <strong className="text-white">youth-focused revival gathering</strong> carrying a burden for the next generation to be{' '}
            <span style={{ color: '#ECD9A0' }}>saved</span>,{' '}
            <span style={{ color: '#ECD9A0' }}>restored</span>,{' '}
            <span style={{ color: '#ECD9A0' }}>awakened</span>, and established in the presence of God.
          </p>
          <p className="text-base md:text-lg text-gray-300 leading-loose" style={{ fontFamily: "'Glacial Indifference', sans-serif" }}>
            This is <strong className="text-white">more than an event</strong>. It is a call to{' '}
            <span style={{ color: '#D4A842', fontWeight: 600 }}>reclaim hearts</span>,{' '}
            <span style={{ color: '#D4A842', fontWeight: 600 }}>reclaim worship</span>,{' '}
            <span style={{ color: '#D4A842', fontWeight: 600 }}>reclaim purpose</span>, and{' '}
            <span style={{ color: '#D4A842', fontWeight: 600 }}>reclaim a generation</span> for Jesus Christ.
          </p>
        </div>

        {/* Pillars */}
        <div
          className="rounded-2xl overflow-hidden"
          style={{
            border: '1px solid rgba(212,168,66,0.22)',
            background: 'linear-gradient(145deg, rgba(212,168,66,0.06) 0%, rgba(255,255,255,0.015) 100%)',
          }}
        >
          {pillars.map((p, idx) => (
            <div key={p.label}>
              <div className="flex items-center justify-center gap-4 py-5 px-6">
                <div
                  className="w-px self-stretch flex-shrink-0"
                  style={{ background: 'rgba(212,168,66,0.35)', minHeight: '20px' }}
                />
                <i className={`${p.icon} text-base flex-shrink-0`} style={{ color: '#D4A842' }} />
                <span
                  className="text-sm md:text-base font-bold uppercase tracking-[0.18em]"
                  style={{ fontFamily: "'Glacial Indifference', sans-serif", color: '#FFFFFF' }}
                >
                  {p.label}
                </span>
                <div
                  className="w-px self-stretch flex-shrink-0"
                  style={{ background: 'rgba(212,168,66,0.35)', minHeight: '20px' }}
                />
              </div>
              {idx < pillars.length - 1 && (
                <div
                  className="h-px mx-8"
                  style={{ background: 'linear-gradient(90deg, transparent, rgba(212,168,66,0.25), transparent)' }}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutConference;
